import React from "react";
import {FormattedMessage} from "react-intl";
import classNames from "classnames/bind";
import {PRIVATE_CHAT_LIST, VOICE_CHAT_TYPE} from "utils/constants";
import Header from "./Components/Header";
import List from "./Components/List";
import Footer from "./Components/Footer";
import UserSearch from "./Components/UserSearch";
import floatingIcon from "images/voiceChat/voice_chat_float_icon.svg";
import styles from "./index.module.scss";

const View = ({
  isSelfieModeActive,
  voiceChatType,
  isShowVoiceChat,
  userList,
  miniMode,
  privateTab,
  prevPrivateTab,
  privateChatStatus,
  micStatus,
  audioStatus,
  callId,
  agoraPrivateClient,
  currentChatMode,
  volumeData,
  privateOtherPersonName,
  onClickViewMode,
  onClickTypeTab,
  onClickPrivateTab,
  onClickEnterChat,
  onClickLeaveChat,
  getDevices,
  switchDevice,
  getVolume,
  setVolume,
  micTestStart,
  micTestStop,
  speakerTestStart,
  speakerTestStop,
  setMuted,
  getUserAttributes,
  sendCall,
  getMembers,
  setStatus,
  worldName,
}) => {
  const cn = classNames.bind(styles);
  const isWorldMode = currentChatMode === VOICE_CHAT_TYPE[0];
  return (
    <div
      className={cn(
        "voice_chat",
        !isSelfieModeActive && isShowVoiceChat && "show",
        miniMode && "mini_mode",
      )}
    >
      <Header
        voiceChatType={voiceChatType}
        miniMode={miniMode}
        onClickViewMode={onClickViewMode}
        onClickTypeTab={onClickTypeTab}
      />
      <List
        voiceChatType={voiceChatType}
        userList={userList}
        miniMode={miniMode}
        privateTab={privateTab}
        currentChatMode={currentChatMode}
        volumeData={volumeData}
        privateChatStatus={privateChatStatus}
        onClickPrivateTab={onClickPrivateTab}
        getUserAttributes={getUserAttributes}
        sendCall={sendCall}
        callId={callId}
        setVolume={setVolume}
        onClickLeaveChat={onClickLeaveChat}
        onClickEnterChat={onClickEnterChat}
        agoraPrivateClient={agoraPrivateClient}
        worldName={worldName}
      />
      {privateTab === PRIVATE_CHAT_LIST[3] && (
        <UserSearch
          prevPrivateTab={prevPrivateTab}
          privateChatStatus={privateChatStatus}
          onClickPrivateTab={onClickPrivateTab}
          getMembers={getMembers}
          getUserAttributes={getUserAttributes}
          sendCall={sendCall}
        />
      )}
      <Footer
        miniMode={miniMode}
        voiceChatType={voiceChatType}
        currentChatMode={currentChatMode}
        privateChatStatus={privateChatStatus}
        onClickEnterChat={onClickEnterChat}
        onClickLeaveChat={onClickLeaveChat}
        getDevices={isWorldMode ? getDevices : agoraPrivateClient.getDevices}
        switchDevice={
          isWorldMode ? switchDevice : agoraPrivateClient.switchDevice
        }
        getVolume={isWorldMode ? getVolume : agoraPrivateClient.getVolume}
        setVolume={isWorldMode ? setVolume : agoraPrivateClient.setVolume}
        micTestStart={
          isWorldMode ? micTestStart : agoraPrivateClient.micTestStart
        }
        micTestStop={isWorldMode ? micTestStop : agoraPrivateClient.micTestStop}
        speakerTestStart={
          isWorldMode ? speakerTestStart : agoraPrivateClient.speakerTestStart
        }
        speakerTestStop={
          isWorldMode ? speakerTestStop : agoraPrivateClient.speakerTestStop
        }
        micStatus={isWorldMode ? micStatus : agoraPrivateClient.micStatus}
        audioStatus={isWorldMode ? audioStatus : agoraPrivateClient.audioStatus}
        setMuted={isWorldMode ? setMuted : agoraPrivateClient.setMuted}
        setStatus={setStatus}
      />
      {currentChatMode !== VOICE_CHAT_TYPE[2] && (
        <div className={cn("meeting")}>
          <img src={floatingIcon} alt="" />
          {currentChatMode === VOICE_CHAT_TYPE[0] ? (
            <FormattedMessage id="ID_VOICE_CHAT_WORLD_CHATTING" />
          ) : (
            <FormattedMessage
              id="ID_VOICE_CHAT_FLOATING_CHATTING"
              values={{
                user: <span>{privateOtherPersonName}</span>,
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default View;
